// src/layouts/pages/finantial/invoice-list/index.js
import { useEffect, useRef, useState, useContext } from 'react';
import Card from '@mui/material/Card';
import Swal from 'sweetalert2';
import axios from 'axios';
import SoftBox from 'components/SoftBox';
import DashboardLayout from 'prefabsComponents/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import Footer from 'prefabsComponents/Footer';
import DataTable from 'prefabsComponents/Tables/DataTable';
import fetchData from 'layouts/pages/finantial/invoice-list/data/dataTableData';
import ModalCobranza from 'layouts/pages/finantial/invoice-list/components/ModalCobranza';
import ModalFiltros from './components/ModalFiltros';
import AccionesCell from './components/AccionesCell';
import DataTableLoader from 'components/DataTableLoader';
import DataTableHeaderOptions from 'components/DataTableHeaderOptions';
// import StatusCell from 'layouts/ecommerce/orders/order-list/components/StatusCell'; // (si no lo usas, elimina esta import)

// Auth
import { AuthContext } from 'context/AuthContext';

const InvoiceList = () => {
  const currentPageData = useRef([]);
  const [dataTableData, setDataTableData] = useState({ columns: [], rows: [] });
  const [isLoading, setIsLoading] = useState(true);

  // Solo admin/user pueden crear cobranzas
  const { hasRole } = useContext(AuthContext);
  const canCreate = hasRole('admin', 'user');

  const onApplyFilters = async (filters) => {
    setIsLoading(true);
    try {
      const queryParams = new URLSearchParams();
      if (filters.cliente) queryParams.append('cliente', filters.cliente.label);
      if (filters.fechaDesde) queryParams.append('fechaDesde', filters?.fechaDesde ? filters.fechaDesde.toISOString().split('T')[0] : null);
      if (filters.fechaHasta) queryParams.append('fechaHasta', filters.fechaHasta ? filters.fechaHasta.toISOString().split('T')[0] : null);
      if (filters.moneda) queryParams.append('moneda', filters.moneda.label);
      if (filters.estado) queryParams.append('estado', filters.estado.value);

      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/finance/invoice/?${queryParams.toString()}`);
      const data = response.data;
      setDataTableData({
        columns: dataTableData.columns,
        rows: data.map(row => ({
          id: row.id_cobranza,
          fechaEmision: row.fecha,
          estado: row.estado,
          rut: row.rut,
          moneda: row.moneda,
          cliente: [row.cliente, { image: row.cliente.charAt(0) }],
          tipoCambio: row.cambio,
          valor: row.valor,
        })),
      });
    } catch (error) {
      console.error('Error applying filters:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getData = async () => {
    try {
      setIsLoading(true);
      const data = await fetchData();
      setDataTableData(data);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un error al cargar los datos',
        timer: 2000,
        timerProgressBar: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  // ⬇️ Props condicionales para ocultar el botón "Nueva Cobranza"
  const createProps = canCreate
    ? { CreateNewModal: ModalCobranza, createNewTitle: 'Nueva Cobranza' }
    : {};

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Si no puede crear, no pasamos props => el botón NO se renderiza */}
      <DataTableHeaderOptions
        dataTableData={dataTableData}
        FilterModal={ModalFiltros}
        getData={getData}
        {...createProps}
        currentPageData={currentPageData}
        onApplyFilters={onApplyFilters}
      />

      <SoftBox my={3}>
        <Card>
          {isLoading ? (
            <DataTableLoader />
          ) : (
            <DataTable
              onPageData={(data) => { currentPageData.current = data; }}
              canSearch={true}
              entriesPerPage={true}
              showTotalEntries={true}
              table={{
                ...dataTableData,
                rows: dataTableData.rows.map(row => ({
                  ...row,
                  acciones: (
                    <AccionesCell
                      cobranza={row}
                      getData={getData}
                      setIsLoading={setIsLoading}
                    />
                  ),
                })),
              }}
            />
          )}
        </Card>
      </SoftBox>

      <Footer />
    </DashboardLayout>
  );
};

export default InvoiceList;
